import React, { createContext, useEffect, useContext, useMemo } from 'react';
import { WebSocketManager } from './WebSocketManager';

interface WebSocketContextValue {
  instance: WebSocketManager;
}

interface WebSocketProviderProps {
  wsUrl: string;
  children: React.ReactNode;
}

const WebSocketContext = createContext<WebSocketContextValue | undefined>(undefined);

export const WebSocketProvider: React.FC<WebSocketProviderProps> = ({ wsUrl, children }) => {
  const manager = useMemo(() => new WebSocketManager(''), []);

  useEffect(() => {
    manager.setUrl(wsUrl);
    return () => {};
  }, [wsUrl, manager]);

  return (
    <WebSocketContext.Provider value={{ instance: manager }}>
      {children}
    </WebSocketContext.Provider>
  );
};

export const useWebSocket = () => {
  const context = useContext(WebSocketContext);
  if (!context) {
    throw new Error('useWebSocket must be used within a WebSocketProvider');
  }
  return context;
}; 